import React, { lazy, Suspense } from "react";
import Backdrop from "components/common-components/backdrop";

const Default = lazy(() => import("../../../../layouts/dashboard/default"));
const AllUser = lazy(() => import("../pages/all-user"));
const AddUser = lazy(() => import("../pages/add-user"));

export const UserManagementRouter = [
  {
    path: "/user-management",
    element: (
      <Suspense fallback={<Backdrop />}>
        <Default />
      </Suspense>
    ),
    children: [
      {
        path: "listing",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AllUser />
          </Suspense>
        ),
      },
      {
        path: "create",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AddUser />
          </Suspense>
        ),
      },
      {
        path: "edit-user/:id",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AddUser />
          </Suspense>
        ),
      },
    ],
  },
];
